module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows-9404275e1df6c9ab1adca2bedd2ae279.png";